/*@ngInject*/
const checkAuthRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.checkAuth = function () {
        let url = '/rest/v2/Session/checkAuth';

        return this.get(url);
    };
};

angular.module('gw-um-auth')
    .service('checkAuthRepository', checkAuthRepository);
